import React from 'react';

import { Glyph } from './MarketingGlyph.styles';

/**
 * "Marketing" nav glyph: a megaphone (Material Symbols `campaign`, filled, weight 400, its body drawn taller so it
 * carries the same optical weight as the filled Home / Website glyphs beside it), for the
 * section holding the brand's marketing material (Marketing Assets). Drawn inline with
 * `fill="currentColor"` on the path so the nav's active/hover `path[fill]` rule can recolour it, like the
 * Players / Website glyphs; the idle colour comes from the nav-icon token on the `Glyph` wrapper.
 */
export type MarketingGlyphProps = {
  size?: number;
  className?: string;
};

export const MarketingGlyph = ({ size = 24, className }: MarketingGlyphProps): React.ReactElement => (
  <Glyph className={className} aria-hidden="true">
    {/* Optically matched to the filled Home / Website glyphs: the megaphone body is stretched 1.35x tall about
        its centre and the sound lines drawn at 0.85, so the bullhorn itself carries the height; the viewBox is
        cropped to the drawing (the symbol's 960 grid pads it for the sound lines). */}
    <svg width={size} height={size} viewBox="90 -850 780 740" fill="none">
      <g transform="translate(0 -460) scale(1 1.35) translate(0 460)">
        <path
          fill="currentColor"
          d="M200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80ZM560-346v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346Z"
        />
      </g>
      <g transform="translate(780 -480) scale(0.85) translate(-780 480)">
        <path
          fill="currentColor"
          d="M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96Z"
        />
      </g>
    </svg>
  </Glyph>
);

export default MarketingGlyph;
